var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 42.667,
    viewBox: "0 0 32 42.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2648da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26d9bc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-2405 -1992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.421.66a.964.964,0,0,1,1.829,0l1.72,5.165A7.706,7.706,0,0,0,20.847,10.7l5.162,1.72a.964.964,0,0,1,0,1.829l-5.165,1.72a7.706,7.706,0,0,0-4.874,4.877l-1.72,5.163a.963.963,0,0,1-1.829,0L10.7,20.844a7.706,7.706,0,0,0-4.874-4.875L.662,14.249a.963.963,0,0,1,0-1.829L5.827,10.7A7.706,7.706,0,0,0,10.7,5.825L12.421.66Z",
    transform: "translate(2410.331 2007.995)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M7.452.4a.579.579,0,0,1,1.1,0L9.582,3.5a4.629,4.629,0,0,0,2.925,2.925l3.1,1.032a.579.579,0,0,1,0,1.1l-3.1,1.032a4.624,4.624,0,0,0-2.925,2.925l-1.032,3.1a.579.579,0,0,1-1.1,0l-1.032-3.1A4.624,4.624,0,0,0,3.5,9.583L.4,8.551a.579.579,0,0,1,0-1.1L3.5,6.421A4.624,4.624,0,0,0,6.42,3.5Z",
    transform: "translate(2405 1994.661)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M4.961.26a.387.387,0,0,1,.731,0l.688,2.064A3.079,3.079,0,0,0,8.331,4.276l2.064.688a.387.387,0,0,1,0,.731l-2.064.688A3.083,3.083,0,0,0,6.379,8.335L5.691,10.4a.387.387,0,0,1-.731,0L4.273,8.335A3.083,3.083,0,0,0,2.321,6.383L.26,5.695a.387.387,0,0,1,0-.731l2.064-.688A3.079,3.079,0,0,0,4.276,2.324L4.961.263Z",
    transform: "translate(2426.34 1992)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48);
export default __webpack_public_path__ + "static/media/Group 48.5ecd7441ec43da1442094aa9f1ea4b2c.svg";
export { ForwardRef as ReactComponent };